export default "__VITE_ASSET__CdFZcoGd__"